import React from 'react';
import VideoSection from '../../organisms/Sections/VideoSection/VideoSection';

const videoSection = ({ block }) => (
  <VideoSection title={block.name} caption={block.caption} href={block.href} imageUrl={block.image.asset.url} useOrderButton={block.useOrderButton} />
);

export default videoSection;